import classnames from 'classnames'
import ReadMore from '../readMore'
import ReviewStars from '../reviews/reviewStars'
import styles from './productReviewHighLight.module.scss'

export interface ProductReviewHighLightProps {
  title: string
  avgRating: number
  children: string
  className?: string
}
const ProductReviewHighLight = ({ children, className, avgRating, title }: ProductReviewHighLightProps) => {
  const classes = classnames(styles.container, className)
  return (
    <div className={classes}>
      <ReviewStars totalStars={5} fillStars={avgRating} />
      <div className={styles.container__title}>{title}</div>
      <ReadMore className={styles.container__body}>{children}</ReadMore>
    </div>
  )
}
export default ProductReviewHighLight
